// extracted by mini-css-extract-plugin
export default {"pressWrapper":"press_pressWrapper__sq3du","img":"press_img__qwVPw"};